export const setCanvasStyle = function (map, style) {
  for (const key in style) {
    map.getCanvas().style[key] = style[key]
  }
}
